import React from 'react';
import Helmet from 'react-helmet';
import Waypoint from 'react-waypoint';

import ArModels from 'api/resources/arModels';
import getErrors from 'utils/getErrors';
import { Deserializer } from 'jsonapi-serializer';

import { ReactComponent as IconAR } from 'icons/ar.svg';

import CardsStub from 'admin-editor/components/CardsStub';
import FiltersDropdown from 'components/FiltersDropdown';
import ARItem from 'admin-editor/components/ARItem';
import LoadARModel from 'admin-editor/containers/LoadARModel';

import ErrorText from 'styled/Page/ErrorText';
import Main from 'styled/Page/Main';
import FilterWrapper from 'styled/Page/FilterWrapper';
import CenteredContainer from 'styled/Page/CenteredContainer';
import RightColumn from 'styled/Page/RightColumn';

import CardsList from 'styled/Page/CardsList';

const SORT_FILTERS = [
  {
    label: 'От новых к старым',
    value: '-created_at',
  }, {
    label: 'От старых к новым',
    value: 'created_at',
  },
];

const PAGE_SIZE = 12;

class ARPage extends React.PureComponent {
  state = {
    hasMore: false,
    loading: false,
    models: [],
    errors: [],
    sort: SORT_FILTERS[0],
  }

  componentDidMount() {
    this.loadModels();
  }

  get cursor() {
    if (this.state.models.length === 0) return undefined;
    return this.state.models[this.state.models.length - 1].id;
  }

  handleFilterChange = (sort = {}) => {
    window.scrollTo(0, 0);

    this.setState({
      sort,
      models: [],
    }, this.loadModels);
  }

  handleCreate = (model) => {
    this.setState((prevState) => {
      let models;
      if (prevState.sort.value === SORT_FILTERS[0].value) {
        models = [model].concat(prevState.models);
      } else {
        models = prevState.hasMore ? prevState.models : prevState.models.concat(model);
      }

      return ({ models });
    });
  }

  handleDelete = (model) => {
    this.setState(prevState => ({
      models: prevState.models.filter(item => item.id !== model.id),
    }));
  }

  handleUpdate = (model) => {
    this.setState(prevState => ({
      models: prevState.models.map(item => (item.id === model.id ? model : item)),
    }));
  }

  loadModels = async () => {
    this.setState({
      loading: true,
      errors: [],
    });

    try {
      const response = await ArModels.getAll({
        page: {
          cursor: this.cursor,
          size: PAGE_SIZE,
        },
        sort: this.state.sort.value,
        include: 'cover',
        fields: {
          augmented_reality_model: 'title,cover,created_at',
          image: 'url',
        },
      });

      const models = await new Deserializer({ keyForAttribute: 'camelCase' }).deserialize(response);

      this.setState(prevState => ({
        models: prevState.models.concat(models),
        loading: false,
        hasMore: models.length === PAGE_SIZE,
      }));
    } catch (err) {
      getErrors(err).then((errors) => {
        this.setState({
          errors,
          loading: false,
        });
      });
    }
  }

  render() {
    return (
      <Main>
        <Helmet><title>AR модели</title></Helmet>

        <div style={{ width: '100%' }}>
          <FilterWrapper style={{ paddingBottom: '8px', paddingTop: '15px' }}>
            <FiltersDropdown
              filters={SORT_FILTERS}
              onFilterChange={this.handleFilterChange}
              style={{ width: '170px', marginRight: 'auto' }}
              activeFilter={this.state.sort}
            />
          </FilterWrapper>

          <CardsList>
            {this.state.errors.length === 0 && (
              this.state.models.map(item => (
                <ARItem
                  key={item.id}
                  id={item.id}
                  title={item.title}
                  coverUrl={item.cover && item.cover.url}
                  createdAt={item.createdAt}
                  onDelete={this.handleDelete}
                  onUpdate={this.handleUpdate}
                />
              ))
            )}

            {this.state.loading && (
              Array.from({ length: PAGE_SIZE }, () => <CardsStub key={Math.random()} />)
            )}
          </CardsList>

          {this.state.errors.length > 0 && (
            <CenteredContainer>
              {this.state.errors.map(error => (
                <ErrorText role="alert" key={error}>{error}</ErrorText>
              ))}
            </CenteredContainer>
          )}

          {!this.state.loading &&
            this.state.models.length === 0 &&
            this.state.errors.length === 0 && (
            <CenteredContainer>
              <IconAR />

              <ErrorText>Модели не найдены</ErrorText>
            </CenteredContainer>
          )}

          {this.state.hasMore && <Waypoint onEnter={this.loadModels} />}
        </div>

        <RightColumn>
          <LoadARModel onCreate={this.handleCreate} />
        </RightColumn>
      </Main>
    );
  }
}

export default ARPage;
